<template>
    <rkm-area
        background-color="info"
        closed
        header-prefix-icon="clipboard-check"
        title="Reavaliações"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.reavaliacoes"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">

                        <rkm-row>
                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.dataReavaliacao"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.horaReavaliacao"
                                    label="Horário"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => item.profissional"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.reavaliacao"
                                    label="Reavaliação"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {    components: {

        Item
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>